import { Element as XmlElement } from '@xmpp/xml';
import { ActionTree } from 'vuex';

import {
  buildSendMessage,
  Message,
  MessageType,
} from './message_builders';
import { StateType } from './state';

type XmppRequest = { jid: string };
type XmppFetchRequest = XmppRequest & { seq: number };

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const actions: ActionTree<StateType, any> = {
  async fetchXmppMessageBySeq({ dispatch }, { jid, seq }: XmppFetchRequest) {
    const response: XmlElement = await dispatch('fetchHistoryIQ', {
      jid, seq, limit: 1, inclusive: true,
    });

    const history = response.getChild('history-inclusive', 'xmpp:join:history');
    return history?.getChild('message') || null;
  },

  async fetchMessageBySeq({ dispatch }, request: XmppFetchRequest) {
    const xmppMessage: XmlElement | null = await dispatch('fetchXmppMessageBySeq', request);
    if (!xmppMessage) throw new Error('XMPP message could not be retrieved');

    const parsed = await dispatch('parseMessage', { xmppMessage });
    return parsed;
  },

  async sendMessage(
    { dispatch, rootGetters },
    {
      message,
      type,
      toJid,
      groupName
    }: {
      message?: Message<MessageType>,
      type: MessageType,
      toJid: string,
      groupName: string
    },
  ) {
    // Message is always send to a group
    const senderName = rootGetters['apiSession/sessionName']

    const builtMessage = buildSendMessage(message || null, type, senderName, toJid, groupName);

    if (!builtMessage) return;
    await dispatch('xmppClient/send', builtMessage, { root: true });
  },
};

export default actions;